import {pageTo} from 'utils'
import token from 'token'
import { isFlutterApp } from 'android'

function plugin(Vue) {
    if (Vue && Vue.http) {
        Vue.http.interceptors.push({

            request: function(request) {

                // post请求加X-CSRFToken
                // rel: https://docs.djangoproject.com/en/1.8/ref/csrf/
                let params = request.params
                if (request.method === 'get') {
                    if (request.url.indexOf("?")>-1){
                        request.url = request.url + "&_date="+(new Date()).valueOf();
                    }else{
                        request.url = request.url + "?_date="+(new Date()).valueOf();
                    }
                    if(this.$route.query && this.$route.query.user_type){
                        request.url += "&user_type="+this.$route.query.user_type;
                    }
                    //添加loading router beforeeach的时候已经添加("#global_loading")了，不用新增dom
                    let isLoading = request.url.indexOf('noLoading') > -1 || params.noLoading
                    !isLoading && $("#global_loading").show()
                }

                if (request.method === 'post' || request.method === 'patch' || process.env.NODE_ENV !== 'production') {
                    request.headers['X-CSRFToken'] = token()
                }
                // Flutter 设置 sessionid
                if (localStorage) {
                    let sessionid = localStorage.getItem('sessionid')
                    let client = localStorage.getItem('x-client') || 'web'
                    if (sessionid) {
                        request.headers['x-mobile-sessid'] = sessionid
                    }
                    request.headers['x-client'] = client
                }
                
                // 获取云盘空间需要university-id
                request.headers['university-id'] = 0
                return request
            },

            response: function(response) {
                //console.dir(response)
                //移除loading
                // $("#global_loading").remove();
                $("#global_loading").hide()

                if(response.data.op && response.data.op == 'redirect'){
                    // 需要先登录
                    window.location.href = '/login/weixinapp/?next=' + encodeURIComponent(window.location.href);

                    // 订阅发布重新登录
                    let pubSub = window.parent && window.parent.PubSub || null;
                    pubSub && pubSub.publish('login', { msg: 'login' });

                    return;
                }

                // fix 网页版中掉线后不知道跳转回扫码页面的情况
                if(response.data.op && response.data.op == 'web_redirect'){
                    // 需要先登录
                    window.parent && window.parent.location.reload()
                    return;
                }
                // 在手机但非微信的浏览器打开要跳走
                // https://www.tapd.cn/20392061/bugtrace/bugs/view?bug_id=1120392061001002619
                if(response.data.op && response.data.op == 'mobile_redirect'){
                    // 需要先登录
                    window.location.href = '/static/html/openinwx.html'
                    return;
                }
                if(response.data.op && response.data.op == 'redirect_bind'){
                    // 清华绑定提示页
                    window.location.href = '/static/html/tsinghua_bind.html'
                    return;
                }

                if(response.data.op && response.data.op == 'k12_redirect_bind'){
                  // k12绑定页面
                  window.location.href = '/v/index/need-bind'
                  return;
                }   
                
                // 云雨打通接口错误 根据sub_code 判断异常原因
                if (response.data.error_code === 40000 && response.data.sub_code) {
                    // sub_code为302 未做身份绑定 跳转至绑定提示页
                    if (response.data.sub_code === 302) {
                        location.href = '/static/html/tsinghua_bind.html?from=2'
                        return 
                    } 
                }


                const request = response.request || {}
                const data = response.data || {}

                // 请求参数skip,则跳过response处理
                // rel: 个人信息编辑页面studentme api
                // if (request.params.skip) {
                //     return response
                // }

                // 接口404 500跳转到错误页面
                // if (response.status === 404 || response.status === 500) {
                //     pageTo(response.status)
                // }

                // 接口显示未登录， 跳转登录页
                // if (data.error && data.error_code === 20005) {
                //     pageTo('login')
                // }
                if ((request.method=='GET') && (data.success==false) && (data.status_code>0)) {
                    var root= Vue.config.vueRouterConfig.root==null?"":Vue.config.vueRouterConfig.root;
                    var name = this.$route.name;
                    var code = data.status_code;
                    var params = this.$route.params;

                    if(data.status_code==5) {
                        if('normalcourse' === name) {
                            return response;
                        }

                        var nexturl = window.location.href;
                        window.location.href = root+`/edituserinfo_simple?next_url=${nexturl}`;
                        return ;
                    }

                    if (request.url.indexOf("/notice_info")>-1){
                        window.location.href = root+"/error/"+ code +"?from=notice_view";
                        return;
                    }
                    window.location.href = root+"/error/"+code;
                    return;
                }

                return response
            }

        })
    }
}

export default plugin



// WEBPACK FOOTER //
// ./src/util/vue-http.js